import type { RadioProps } from 'react-aria-components'
import { Radio as RACRadio } from 'react-aria-components'
import { composeTailwindRenderProps, focusRing } from '~/design-system/helpers'
import tv from '~/lib/tv'

const radioVariants = tv({
  extend: focusRing,
  base: 'min-w-[1.125rem] min-h-[1.125rem] rounded-full border-2 bg-white transition-all',
  variants: {
    isSelected: {
      false: 'border-gray-400 group-pressed:border-gray-500',
      true: 'border-[7px] border-primary-orange forced-colors:!border-[Highlight] group-pressed:border-gray-800',
    },
    isInvalid: {
      true: 'border-red-700 group-pressed:border-red-800 forced-colors:!border-[Mark]',
    },
    isDisabled: {
      true: 'border-gray-200 forced-colors:!border-[GrayText]',
    },
  },
})

export default function Radio(props: RadioProps) {
  return (
    <RACRadio
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        'flex gap-2 items-center group text-primay-black disabled:text-gray-300 forced-colors:disabled:text-[GrayText] text-sm transition',
      )}
    >
      {(renderProps) => (
        <>
          <div className={radioVariants(renderProps)} />
          {props.children}
        </>
      )}
    </RACRadio>
  )
}
